<template>
    <div class="clearfix rounded pb-5 mx-auto">
        <!-- Abdullah Changed class here was clearfix company-form-container rounded mt-4 pb-5 mx-auto -->

        <!-- Abdullah added this code here -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0" v-if="this.flg != 1">Payroll Settings<span>
                <!-- AbdullahALC chnaged pageurl to api url -->
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / Payroll Settings / Tax
                Settings</span>
        </h4>

        <div class="row mt-4" :class="{ 'no-margin': this.flg != 1 }"> <!-- Abdullah added this code here -->
            <div class="col-md-12" :class="{ 'ibox': this.flg != 1 }"> <!-- Abdullah added this code here -->
                <div class="ibox-title dashboard_title px-0" v-if="this.flg != 1">
                    <!-- Abdullah changed class here. was justify-content-center py-2 mb-3 border-bottom-->
                    <!-- Abdullah commented this code -->
                    <!-- <div class="col-sm-6 px-3 company-form-box-title">Tax Settings</div>  -->
                    <!-- Abdullah added this code here  -->
                    <h4>Tax Settings</h4>
                </div>
                <div class="ibox-content"> <!-- Abdullah added this code here  -->
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-overlay :show="showoverlay" rounded="sm">
                            <div class="clearfix">

                                <div class="col-md-12 px-3">

                                    <!-- Tax enable/disable updates -->
                                    <div class="col-sm-6 pl-0 mb-2 text-secondary font-medium" style="font-size: 18px;">
                                        Tax Calculation</div> <!-- Abdullah added class and style -->
                                    <p class="mt-2 text-secondary mb-3">Option to choose automated tax calculation for
                                        payroll:</p> <!-- Abdullah added class and style -->

                                    <!-- Abdullah after live chnaged this btn. tell mustafij vai to comment old btn and paste new btn insted of replacing that  -->
                                    <div class="toggle_button_tax">
                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                            <label data-v-25adc6c0="" class="vue-js-switch toggled">

                                                <input data-v-25adc6c0="" type="radio"
                                                    v-model="fdata.tax_calculation_setting"
                                                    class="v-switch-input trz_tax_radio"
                                                    name="atl_tax_calculation_setting" value="1"
                                                    :disabled="isAccessDisabled()">

                                                <div data-v-25adc6c0="" class="v-switch-core" :style="{
                                                    width: '50px',
                                                    height: '22px',
                                                    borderRadius: '11px',
                                                    backgroundColor: fdata.tax_calculation_setting == 1 ? '#38c172' : '#e3342f'
                                                }">
                                                    <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                </div>

                                                <!---->
                                            </label>
                                        </div>

                                        <div class="col-sm-5 trz_tax_button font-semi-bold">
                                            Enable
                                        </div> <!--Abdullah added class here font-semi-bold-->
                                    </div>

                                    <!-- Abdullah after live chnaged this btn. tell mustafij vai to comment old btn and paste new btn insted of replacing that  -->
                                    <div class="toggle_button_tax mb-5">
                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                            <label data-v-25adc6c0="" class="vue-js-switch toggled">

                                                <input data-v-25adc6c0="" type="radio"
                                                    v-model="fdata.tax_calculation_setting"
                                                    class="v-switch-input trz_tax_radio"
                                                    name="atl_tax_calculation_setting" value="2"
                                                    :disabled="isAccessDisabled()">

                                                <div data-v-25adc6c0="" class="v-switch-core" :style="{
                                                    width: '50px',
                                                    height: '22px',
                                                    borderRadius: '11px',
                                                    backgroundColor: fdata.tax_calculation_setting == 2 ? '#38c172' : '#e3342f'
                                                }">
                                                    <!-- Abdullah chmaged background color -->
                                                    <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                </div>

                                                <!---->
                                            </label>
                                        </div>

                                        <div class="col-sm-5 trz_tax_button font-semi-bold">
                                            Disable
                                        </div>
                                        <!--Abdullah added class here font-semi-bold-->
                                    </div>
                                    <!-- Tax enable/disable updates -->

                                    <!-- PAYE updates -->
                                    <div class="col-sm-6 pl-0 mb-2 text-secondary font-medium" style="font-size: 18px;">
                                        Tax Allocation Method</div>
                                    <!-- Abdullah chnaged class here and style. was col-sm-6 company-form-box-title pl-0 mb-2-->
                                    <p class="mt-2 text-secondary mb-3">Option to choose the tax spreading methodology
                                        for payroll:</p> <!-- Abdullah added css class here.-->


                                <!-- Abdullah after live chnaged this btn. tell mustafij vai to comment old btn and paste new btn insted of replacing that  -->
                                    <div class="toggle_button_tax">
                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                            <label data-v-25adc6c0="" class="vue-js-switch toggled">

                                                <input data-v-25adc6c0="" type="radio"
                                                    v-model="fdata.tax_allocation_method"
                                                    class="v-switch-input trz_tax_radio"
                                                    name="atl_tax_allocation_method" value="1"
                                                    :disabled="isAccessDisabled()">

                                                <div data-v-25adc6c0="" class="v-switch-core" :style="{
                                                    width: '50px',
                                                    height: '22px',
                                                    borderRadius: '11px',
                                                    backgroundColor: fdata.tax_allocation_method == 1 ? '#38c172' : '#e3342f'
                                                }">
                                                    <!-- Abdullah chmaged background color -->
                                                    <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                </div>

                                                <!---->
                                            </label>
                                        </div>

                                        <div class="col-sm-5 trz_tax_button font-semi-bold">
                                            Spread Tax Equally over the Fiscal Year
                                        </div> <!--Abdullah added class here font-semi-bold-->
                                    </div>


                                    <!-- Abdullah after live chnaged this btn. tell mustafij vai to comment old btn and paste new btn insted of replacing that  -->
                                    <div class="toggle_button_tax mb-5">
                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                            <label data-v-25adc6c0="" class="vue-js-switch toggled">

                                                <input data-v-25adc6c0="" type="radio"
                                                    v-model="fdata.tax_allocation_method"
                                                    class="v-switch-input trz_tax_radio"
                                                    name="atl_tax_allocation_method" value="2"
                                                    :disabled="isAccessDisabled()">

                                                <div data-v-25adc6c0="" class="v-switch-core" :style="{
                                                    width: '50px',
                                                    height: '22px',
                                                    borderRadius: '11px',
                                                    backgroundColor: fdata.tax_allocation_method == 2 ? '#38c172' : '#e3342f'
                                                }">
                                                    <!-- Abdullah chmaged background color -->
                                                    <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                </div>

                                                <!---->
                                            </label>
                                        </div>

                                        <div class="col-sm-5 trz_tax_button font-semi-bold">
                                            Spread Tax as per Monthly Income (PAYE)
                                        </div> <!--Abdullah added class here font-semi-bold-->
                                    </div>
                                    <template v-if="fdata.tax_allocation_method == 2">
                                        <div class="col-sm-6 company-form-box-title pl-0 mb-2">Select From Fiscal Year
                                        </div>
                                        <b-form-group id="paye_fiscal_year-group" label=""
                                            class="required-field mt-2 mb-5" label-for="paye_fiscal_year">
                                            <b-form-select id="paye_fiscal_year" name="paye_fiscal_year"
                                                v-model="fdata.paye_fiscal_year" v-validate="{ required: true }"
                                                :options="paye_fiscal_years" :state="validateState('paye_fiscal_year')"
                                                aria-describedby="paye_fiscal_year-feedback" data-vv-as="Fiscal Year"
                                                :disabled="isAccessDisabled()"></b-form-select>
                                            <b-form-invalid-feedback id="paye_fiscal_year-feedback">{{
                                                veeErrors.first('paye_fiscal_year') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>

                                    <div class="row mb-5" v-if="fdata.tax_allocation_method == 2">

                                        <div class="col-md-12">
                                            <div class="card h-100 red-shadow">
                                                <div class="card-body">
                                                    <h5 class="mb-3 border-bottom pb-3"><b-icon icon="info-circle"
                                                            class="mr-2 align-custom"></b-icon>Note
                                                    </h5>
                                                    <p>Payruns already processed for the selected fiscal year cannot be
                                                        updated. To apply changes, existing
                                                        payruns must be deleted first.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- PAYE updates -->



                                    <div class="col-sm-6 pl-0 mb-2 text-secondary font-medium" style="font-size: 18px;">
                                        Investment Rebate</div>
                                    <!-- Abdullah chnaged class here and style. was col-sm-6 company-form-box-title pl-0 mb-2-->
                                    <p class="mt-2 text-secondary mb-3">An employee shall be entitled to a credit from
                                        the amount of tax payable if he/she
                                        invests during the income year in certain schemes. The tax credit on investment
                                        will be the lesser of:<br /><br />a.
                                        0.03 of total taxable income<br />b. 0.10 of actual investment declared during
                                        the fiscal year<br /> c. Tk.
                                        750,000<br /><br />Usually employee investment information is available
                                        towards the middle/end of the tax year.
                                        Therefore, it is important for an employer to set a policy at the beginning of
                                        the tax year whether to give maximum
                                        rebate on employee's Total Taxable Income. Please choose the policy applicable
                                        for your organization:</p>
                                    <!-- Abdullah added css class here.-->
                                    <!--<p class="mt-2">An employee shall be entitled to a credit from the amount of tax payable if he/she invests during the income year in certain schemes. The eligible investment amount will be the lesser of :<br/><br/>a. Actual investment made<br/>b. 20% of total income<br/> c. Tk. 10,000,000<br/><br/>Usually employee investment information is available towards the middle/end of the tax year. Therefore, it is important for an employer to set a policy at the beginning of the tax year whether to give maximum rebate on employee's Total Taxable Income. Please choose the policy applicable for your organization:</p>-->

                                    <!--
                            <b-form-group id="tax_zone-group" label="" class="required-field" label-for="tax_zone">
                                <b-form-select id="inventment_type" name="inventment_type" v-model="fdata.inventment_type" v-validate="{ required: true }" :options="inventment_types" :state="validateState('inventment_type')"   aria-describedby="inventment_type-feedback" data-vv-as="Investment policy"></b-form-select>
                                <b-form-invalid-feedback id="inventment_type-feedback">{{ veeErrors.first('inventment_type') }}</b-form-invalid-feedback>
                            </b-form-group>
                            -->
                                <!-- Abdullah after live chnaged this btn. tell mustafij vai to comment old btn and paste new btn insted of replacing that  -->
                                    <div class="toggle_button_tax">
                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                            <label data-v-25adc6c0="" class="vue-js-switch toggled">

                                                <input data-v-25adc6c0="" type="radio" v-model="fdata.inventment_type"
                                                    class="v-switch-input trz_tax_radio" name="trz_test" value="1"
                                                    :disabled="isAccessDisabled()">

                                                <div data-v-25adc6c0="" class="v-switch-core" :style="{
                                                    width: '50px',
                                                    height: '22px',
                                                    borderRadius: '11px',
                                                    backgroundColor: fdata.inventment_type == 1 ? '#38c172' : '#e3342f'
                                                }">
                                                    <!--Abdullah chmnaged background color-->
                                                    <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                </div>

                                                <!---->
                                            </label>
                                        </div>

                                        <div class="col-sm-11 trz_tax_button mb-3 font-semi-bold"
                                            style="color: #004242;font-size: 16px;">
                                            Assume maximum investment based on employee Total Taxable Income
                                        </div>
                                        <!--Abdullah added class here font-semi-bold and style-->
                                    </div>



                                    <!-- Abdullah after live chnaged this btn. tell mustafij vai to comment old btn and paste new btn insted of replacing that  -->
                                    <div class="toggle_button_tax">
                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                            <label data-v-25adc6c0="" class="vue-js-switch toggled">

                                                <input data-v-25adc6c0="" type="radio" v-model="fdata.inventment_type"
                                                    class="v-switch-input trz_tax_radio" name="trz_test" value="2"
                                                    :disabled="isAccessDisabled()">

                                                <div data-v-25adc6c0="" class="v-switch-core" :style="{
                                                    width: '50px',
                                                    height: '22px',
                                                    borderRadius: '11px',
                                                    backgroundColor: fdata.inventment_type == 2 ? '#38c172' : '#e3342f'
                                                }">
                                                    <!--Abdullah chmnaged background color-->
                                                    <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                </div>

                                                <!---->
                                            </label>
                                        </div>

                                        <div class="col-sm-11 trz_tax_button font-semi-bold"
                                            style="color: #004242;font-size: 16px;">
                                            Assume actual investment
                                        </div>
                                        <!--Abdullah added class here font-semi-bold and style-->

                                    </div>

                                    <!-- Early Return Filling -->
                                    <div class="col-sm-6 pl-0 mb-2 text-secondary font-medium mt-5" style="font-size: 18px;">Early Return Filling</div>
                                    <p class="mt-2 text-secondary mb-3">Assume employees will complete the filing of return targeting Maximum Tax Incentive (Currently 5% of payable tax (max Tk. 25,000)):</p>

                                    <div class="toggle_button_tax">
                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                            <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                <input data-v-25adc6c0="" type="radio" v-model="fdata.max_tax_incentive_filing" class="v-switch-input trz_tax_radio" name="atl_max_tax_incentive_filing" value="1" :disabled="isAccessDisabled()">
                                                <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                    <div data-v-25adc6c0="" class="v-switch-button"></div></div> <!----></label>
                                        </div>
                                        <div class="col-sm-5 trz_tax_button ">Enabled</div>
                                    </div>

                                    <div class="toggle_button_tax mb-5">
                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                            <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                <input data-v-25adc6c0="" type="radio" v-model="fdata.max_tax_incentive_filing" class="v-switch-input trz_tax_radio" name="atl_max_tax_incentive_filing" value="2" :disabled="isAccessDisabled()">
                                                <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                    <div data-v-25adc6c0="" class="v-switch-button"></div></div> <!----></label>
                                        </div>
                                        <div class="col-sm-5 trz_tax_button">Disabled</div>
                                    </div>
                                    <!-- Early Return Filling -->

                                    <!-- Tax Reducers Approval Settings (previously a separate child component,
                                         inlined here so it saves through this form's single Save action) -->
                                    <div class="clearfix row py-2 mb-2 border-bottom mt-5">
                                        <div class="col-sm-12 px-3 company-form-box-title">
                                            Tax Reducers Approval Settings
                                        </div>
                                    </div>
                                    <div class="row px-3">
                                        <div class="col-sm-12">
                                            <template v-for="(value, key, index) in company_access_settings">
                                                <div :key="index">
                                                    <div class="col-sm-6 pl-0 mb-2 text-secondary font-medium mt-5" style="font-size: 18px;">
                                                        {{stringView(key)}}
                                                    </div>

                                                    <div class="toggle_button_tax">
                                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                                            <label class="vue-js-switch" :class="{toggled: company_access_settings[key] === true}">
                                                                <input data-v-25adc6c0="" type="radio" v-model="company_access_settings[key]" class="v-switch-input trz_tax_radio" :name="'atl_'+key" :value="true" :disabled="isAccessDisabled()">
                                                                <div class="v-switch-core" :style="{width: '50px', height: '22px', backgroundColor: company_access_settings[key] === true ? '#38c172' : '#e3342f', borderRadius: '11px'}">
                                                                    <div class="v-switch-button"></div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div class="col-sm-5 trz_tax_button">Enabled</div>
                                                    </div>

                                                    <div class="toggle_button_tax mb-5">
                                                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                                            <label class="vue-js-switch" :class="{toggled: company_access_settings[key] === false}">
                                                                <input data-v-25adc6c0="" type="radio" v-model="company_access_settings[key]" class="v-switch-input trz_tax_radio" :name="'atl_'+key" :value="false" :disabled="isAccessDisabled()">
                                                                <div class="v-switch-core" :style="{width: '50px', height: '22px', backgroundColor: company_access_settings[key] === false ? '#38c172' : '#e3342f', borderRadius: '11px'}">
                                                                    <div class="v-switch-button"></div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div class="col-sm-5 trz_tax_button">Disabled</div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <!-- Tax Reducers Approval Settings -->




                                    <!-- Abdullah commented this  -->
                                    <!-- <div class="col-sm-6 company-form-box-title pl-0 mb-2">Tax Area</div> -->

                                    <!-- Abdullah added this  -->
                                     <!-- alpha fix- added class required-field  -->
                                    <div class="col-sm-6 pl-0 mb-2 text-secondary font-medium mt-5 required-field"
                                        style="font-size: 18px;">Tax Area *</div>
                                    <b-form-group id="tax_zone-group" label="" class="required-field mt-2"
                                        label-for="tax_area">
                                        <b-form-select id="tax_area" name="tax_area" v-model="fdata.tax_area"
                                            v-validate="{ required: true }" :options="tax_areas"
                                            :state="validateState('tax_area')" aria-describedby="tax_area-feedback"
                                            data-vv-as="Tax Area" :disabled="isAccessDisabled()"></b-form-select>
                                        <b-form-invalid-feedback id="tax_area-feedback">{{ veeErrors.first('tax_area')
                                        }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>

                            </div>
                            <template v-if="$acl['company/tax_settings'] > 1">
                                <template v-if="this.flg == 1">
                                    <div class="text-center"> <!--Abdullah added this div.-->
                                        <b-button type="submit" @click="set_go_next()" variant="primary"
                                            class="mt-3 mr-3">Save & Go Next</b-button>
                                        <!-- Abdullah removed class float right and make varient =success  -->
                                        <!-- Abdullah Commented this  -->
                                        <!-- <b-button type="button" @click="set_go_next(1)" variant="primary" class="float-right mt-3 mr-3">Skip</b-button>
                                    <b-button type="button" @click="set_go_back(1)" variant="primary" class="float-right mt-3 mr-3">Go Back</b-button> -->
                                        <b-button type="submit" @click="setfinish()" variant="primary"
                                            class="mt-3 mx-3">Finish</b-button>
                                        <!-- Abdullah removed class float right and make varient =success  -->
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="btn-wrapper text-center pt-5"> <!-- Abdullah chmaged class here  -->
                                        <b-button type="submit" @click="disable_set_go_next()" variant="primary"
                                            class="">Save</b-button>
                                        <!-- Abdullah removed class and make varient =success  -->
                                    </div>
                                </template>
                            </template>
                            <!--<div class="col-sm-12 px-3"><b-button type="submit" variant="primary" class="float-right mt-2">Save</b-button></div>-->


                        </b-overlay>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

    mounted() {
        //
    },
    props: ['flg'],
    components: {
    },
    data() {

        return {

            cu: window.location.href,
            ce: false,
            inventment_types: [{ value: null, text: "Select..." }, { value: 1, text: "Assume maximum investment based on employee Total Taxable Income" }, { value: 2, text: "Assume actual investment" }],
            tax_areas: [{ value: null, text: "Select..." }, { value: 1, text: "Dhaka City Corporation" }, { value: 2, text: "Chattogram City Corporation" }, { value: 3, text: "Other City Corporation" }, { value: 4, text: "Outside of City Corporation" }],
            company_id: 0,

            successmsg: false,
            warningmsg: false,
            dangermsg: false,
            showoverlay: false,
            go_back: false,
            go_next: false,
            finish: false,
            toggle_1: false,
            toggle_2: false,

            errormsg: [],
            fdata: { inventment_type: null, tax_area: null, decimal_point_settings: 'yes', tax_allocation_method: 1, paye_fiscal_year: null, tax_calculation_setting: 1, max_tax_incentive_filing: 2 },
            paye_fiscal_years: [],

            // Tax Reducers Approval Settings (formerly a separate child component)
            company_access_settings: {},

        }
    },
    methods: {


        isAccessDisabled() {
            if (this.$acl['company/tax_settings'] < 2)
                return true;
            else
                return false;
        },
        showMessage: function () {
            let tmp_flg = 0;
            if (this.fdata.tax_zone != null) {
                if (this.fdata.tax_zone.length > 0) tmp_flg = 1;
            }
            let childdata = { flg: tmp_flg, successmsg: this.successmsg, warningmsg: this.warningmsg, dangermsg: this.dangermsg, move_next: this.go_next, move_back: this.go_back, finish: this.finish };
            this.$emit('childToParent', childdata);
        },
        set_go_back(x) {
            this.go_next = false;
            this.go_back = true;
            this.finish = false;

            if (x == 1)
                this.showMessage();
        },
        set_go_next(x) {
            this.go_next = true;
            this.go_back = false;
            this.finish = false;

            if (x == 1)
                this.showMessage();
        },
        disable_set_go_next() {
            this.go_next = false;
        },
        setfinish(x) {
            this.finish = true;

            this.go_next = false;
            this.go_back = false;

            if (x == 1)
                this.showMessage();
        },



        getAcl: function () {
            axios.get(this.$api_url + '/acl', {
                params: {
                    url: this.cu
                }
            }).then(function (response) {
                this.ce = response.data;
            }.bind(this));
        },
        getTaxSettings: function () {

            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/company/taxsettings', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {

                if (parseInt(response.data.company_investment_policy) > 0)
                    this.fdata.inventment_type = response.data.company_investment_policy;

                if (parseInt(response.data.tax_calculation_setting) > 0) {
                    this.fdata.tax_calculation_setting = response.data.tax_calculation_setting;
                }

                if (parseInt(response.data.tax_allocation_method) > 0) {
                    this.fdata.tax_allocation_method = response.data.tax_allocation_method;
                }

                this.fdata.paye_fiscal_year = response.data.paye_fiscal_year;

                if (parseInt(response.data.company_tax_area) > 0)
                    this.fdata.tax_area = response.data.company_tax_area;

                if (response.data.decimal_point_settings)
                    this.fdata.decimal_point_settings = response.data.decimal_point_settings;

                if(parseInt(response.data.max_tax_incentive_filing) > 0){
                    this.fdata.max_tax_incentive_filing = response.data.max_tax_incentive_filing;
                }

                //this.fdata.tax_area = 2;

            }.bind(this)).catch(function (error) { this.serverError(error); });
        },

        // Tax Reducers Approval Settings — formerly the child component's methods
        stringView(str)
        {
            if(str == 'jobposition')
                str = 'job_position';
            var i, frags = str.split('_');
            for (i=0; i<frags.length; i++) {
                frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
            }
            return frags.join(' ');
        },

        get_access_settings: function()
        {
            if(!this.checkNet()) return false;
            axios.get(this.$api_url + '/company/tax-reducers-settings', {
            }).then(function(response){

                let company_access_settings_temp = {};
                company_access_settings_temp = response.data;

                for (const [key, value] of Object.entries(company_access_settings_temp)) {
                    if(value==1)
                    {
                        company_access_settings_temp[key] = true;
                    }
                    else
                    {
                        company_access_settings_temp[key] = false;
                    }
                }

                this.company_access_settings = company_access_settings_temp;

            }.bind(this));
        },

        saveAccessSettings: function()
        {
            var text = JSON.stringify(this.company_access_settings);
            let formData = new FormData();
            formData.append('tax_reducers_settings', text);

            return axios.post(this.$api_url + '/company/tax-reducers-settings/save', formData);
        },

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.successmsg = false;
            this.warningmsg = false;
            this.dangermsg = false;
            //this.showMessage();
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                }

                // Save the main tax settings and the tax reducers approval
                // settings together under this single Save action.
                Promise.all([
                    axios.post(this.$api_url + '/company/savetaxsettings', formData, config),
                    this.saveAccessSettings()
                ])
                    .then(function (responses) {

                        let response = responses[0];

                        if (parseInt(response.data.company_investment_policy) > 0)
                            this.fdata.inventment_type = response.data.company_investment_policy;

                        if (parseInt(response.data.tax_calculation_setting) > 0) {
                            this.fdata.tax_calculation_setting = response.data.tax_calculation_setting;
                        }

                        if (parseInt(response.data.tax_allocation_method) > 0) {
                            this.fdata.tax_allocation_method = response.data.tax_allocation_method;
                        }

                        this.fdata.paye_fiscal_year = response.data.paye_fiscal_year;

                        if (parseInt(response.data.company_tax_area) > 0)
                            this.fdata.tax_area = response.data.company_tax_area;

                        if(parseInt(response.data.max_tax_incentive_filing) > 0){
                            this.fdata.max_tax_incentive_filing = response.data.max_tax_incentive_filing;
                        }

                        if (parseInt(response.data.company_tax_area) > 0)
                            this.$bvToast.toast('Saved!', { title: `Success`, variant: 'success', solid: true });
                        this.showoverlay = false;
                        this.$validator.reset();

                        this.showMessage();

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                        for (var data in currentObj.errormsg) {
                            var msg = currentObj.errormsg[data];
                            currentObj.$bvToast.toast(msg, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });
                            currentObj.$validator.reset();
                        }
                    });
            });
        },




    },
    created: function () {

        this.getTaxSettings();
        this.getAcl();
        this.get_access_settings();
        this.$validator.reset();
        this.paye_fiscal_years = this.getFiscalYearsPaye();
        this.fdata.paye_fiscal_year = this.getFiscalYearsPaye()[0];
    },
    computed:
    {

    },

}
</script>